import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.slice.js";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import axios from "axios";
import { TOGO_DELIVERY_FLOW_ERROR_MESSAGES, TOGO_DELIVERY_FLOW_ERRORS, TOGO_DELIVERY_FLOW_PAYMENT_ERRORS } from "./types/common.types";
import { TOGO_DELIVERY_SUBMIT_ORDER_ERROR_CODES, ERROR_RESPONSE_STATUS_CODE, TOGO_DELIVERY_INITIATE_CHECKOUT_ERROR_CODES } from "@dp/common";
import _ from "lodash";
export var SITE_SETTINGS_FAILED = new Error("SITE_SETTINGS_FAILED");
export var LOGIN_FAILED = new Error("LOGIN_FAILED");
export var PAYMENT_CODE_INVALID = new Error("PAYMENT_CODE_INVALID");
export var PAYMENT_CODE_CHECK_PAID = new Error("PAYMENT_CODE_CHECK_PAID");
export var PAYMENT_CODE_CHECK_CLOSED = new Error("PAYMENT_CODE_CHECK_CLOSED");
export var PAYMENT_CODE_GENERIC_ERROR = new Error("PAYMENT_CODE_GENERIC_ERROR");
export var ErrorResponse = /*#__PURE__*/function (_Error) {
  _inherits(ErrorResponse, _Error);

  var _super = _createSuper(ErrorResponse);

  function ErrorResponse(errObj) {
    var _this;

    _classCallCheck(this, ErrorResponse);

    _this = _super.call(this, null);

    _defineProperty(_assertThisInitialized(_this), "errorResponse", void 0);

    _this.errorResponse = errObj;
    return _this;
  }

  return ErrorResponse;
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var APIErrorResponse = /*#__PURE__*/function (_Error2) {
  _inherits(APIErrorResponse, _Error2);

  var _super2 = _createSuper(APIErrorResponse);

  function APIErrorResponse(errObj) {
    var _this2;

    _classCallCheck(this, APIErrorResponse);

    _this2 = _super2.call(this, null);

    _defineProperty(_assertThisInitialized(_this2), "config", void 0);

    _defineProperty(_assertThisInitialized(_this2), "request", void 0);

    _defineProperty(_assertThisInitialized(_this2), "response", void 0);

    _this2.config = errObj.config;
    _this2.request = errObj.request;
    _this2.response = errObj.response;
    return _this2;
  }

  return APIErrorResponse;
}( /*#__PURE__*/_wrapNativeSuper(Error));

function isInterfaceIAPIError(obj) {
  return (obj === null || obj === void 0 ? void 0 : obj.errors) !== undefined;
}

export var UIError = function UIError(data) {
  _classCallCheck(this, UIError);

  _defineProperty(this, "errors", void 0);

  if (axios.isAxiosError(data)) {
    var _data$response$data$e, _data$response, _data$response$data, _errors$map;

    var errors = (_data$response$data$e = data === null || data === void 0 ? void 0 : (_data$response = data.response) === null || _data$response === void 0 ? void 0 : (_data$response$data = _data$response.data) === null || _data$response$data === void 0 ? void 0 : _data$response$data.errors) !== null && _data$response$data$e !== void 0 ? _data$response$data$e : [];
    this.errors = errors === null || errors === void 0 ? void 0 : (_errors$map = errors.map) === null || _errors$map === void 0 ? void 0 : _errors$map.call(errors, function (err) {
      var _data$response2, _data$response2$data, _data$response3, _data$response3$data;

      var finalError = determineUIErrorCode(err === null || err === void 0 ? void 0 : err.errorCode, data === null || data === void 0 ? void 0 : (_data$response2 = data.response) === null || _data$response2 === void 0 ? void 0 : (_data$response2$data = _data$response2.data) === null || _data$response2$data === void 0 ? void 0 : _data$response2$data.statusCode, err === null || err === void 0 ? void 0 : err.errorMessage);
      return {
        title: "Unexpected Error",
        message: finalError.errorMessage,
        code: finalError.code,
        statusCode: data === null || data === void 0 ? void 0 : (_data$response3 = data.response) === null || _data$response3 === void 0 ? void 0 : (_data$response3$data = _data$response3.data) === null || _data$response3$data === void 0 ? void 0 : _data$response3$data.statusCode
      };
    });
  } else if (isInterfaceIAPIError(data)) {
    var _data$errors, _data$errors$map;

    this.errors = data === null || data === void 0 ? void 0 : (_data$errors = data.errors) === null || _data$errors === void 0 ? void 0 : (_data$errors$map = _data$errors.map) === null || _data$errors$map === void 0 ? void 0 : _data$errors$map.call(_data$errors, function (err) {
      var finalError = determineUIErrorCode(err === null || err === void 0 ? void 0 : err.errorCode, data === null || data === void 0 ? void 0 : data.statusCode, err === null || err === void 0 ? void 0 : err.errorMessage);
      return {
        title: "Unexpected Error",
        message: finalError.errorMessage,
        code: finalError.code,
        statusCode: data === null || data === void 0 ? void 0 : data.statusCode
      };
    });
  } else {
    this.errors = [{
      title: "Unexpected Error",
      message: data === null || data === void 0 ? void 0 : data.message
    }];
  }
};
export var LocationTimeUIError = /*#__PURE__*/function (_UIError) {
  _inherits(LocationTimeUIError, _UIError);

  var _super3 = _createSuper(LocationTimeUIError);

  function LocationTimeUIError(data) {
    var _this3;

    _classCallCheck(this, LocationTimeUIError);

    _this3 = _super3.call(this, data);

    if (axios.isAxiosError(data)) {
      var _data$response4;

      var res = (_data$response4 = data.response) === null || _data$response4 === void 0 ? void 0 : _data$response4.data;
      var errors = res === null || res === void 0 ? void 0 : res.errors;

      if ((errors === null || errors === void 0 ? void 0 : errors.length) > 0) {
        var _errors$map2; // eslint-disable-next-line sonarjs/no-identical-functions


        _this3.errors = errors === null || errors === void 0 ? void 0 : (_errors$map2 = errors.map) === null || _errors$map2 === void 0 ? void 0 : _errors$map2.call(errors, function (err) {
          return {
            title: "Unexpected Error",
            message: err === null || err === void 0 ? void 0 : err.errorMessage,
            code: err === null || err === void 0 ? void 0 : err.errorCode
          };
        });
      } else {
        _this3.errors = [{
          title: "Unexpected Error",
          message: res === null || res === void 0 ? void 0 : res.statusMessage,
          unavailableItems: res === null || res === void 0 ? void 0 : res.unavailableItems
        }];
      }
    } else {
      _this3.errors = [{
        title: "Unexpected Error",
        message: data === null || data === void 0 ? void 0 : data.message
      }];
    }

    return _this3;
  }

  return LocationTimeUIError;
}(UIError);
export var InitiateCheckoutUIError = /*#__PURE__*/function (_UIError2) {
  _inherits(InitiateCheckoutUIError, _UIError2);

  var _super4 = _createSuper(InitiateCheckoutUIError);

  function InitiateCheckoutUIError(data) {
    var _this4;

    _classCallCheck(this, InitiateCheckoutUIError);

    _this4 = _super4.call(this, data);

    if (axios.isAxiosError(data)) {
      var _data$response5;

      var res = (_data$response5 = data.response) === null || _data$response5 === void 0 ? void 0 : _data$response5.data;
      var errors = res === null || res === void 0 ? void 0 : res.errors;

      if ((errors === null || errors === void 0 ? void 0 : errors.length) > 0) {
        var _errors$map3; // eslint-disable-next-line sonarjs/no-identical-functions


        _this4.errors = errors === null || errors === void 0 ? void 0 : (_errors$map3 = errors.map) === null || _errors$map3 === void 0 ? void 0 : _errors$map3.call(errors, function (err) {
          var _res$statusCode;

          var finalError = determineUIErrorCode(err === null || err === void 0 ? void 0 : err.errorCode, (_res$statusCode = res.statusCode) === null || _res$statusCode === void 0 ? void 0 : _res$statusCode.toString(), err === null || err === void 0 ? void 0 : err.errorMessage);
          return {
            title: "Unexpected Error",
            message: finalError.errorMessage,
            code: finalError.code,
            unavailableItems: res === null || res === void 0 ? void 0 : res.unavailableItems,
            statusMessage: res === null || res === void 0 ? void 0 : res.statusMessage
          };
        });
      } else {
        _this4.errors = [{
          title: "Unexpected Error",
          message: res === null || res === void 0 ? void 0 : res.statusMessage,
          unavailableItems: res === null || res === void 0 ? void 0 : res.unavailableItems,
          statusMessage: res === null || res === void 0 ? void 0 : res.statusMessage
        }];
      }
    } else {
      _this4.errors = [{
        title: "Unexpected Error",
        message: data === null || data === void 0 ? void 0 : data.message
      }];
    }

    return _this4;
  }

  return InitiateCheckoutUIError;
}(UIError);

function determineUIErrorCode(errorCode, statusCode, errorMessage) {
  var finalError = {
    code: errorCode,
    errorMessage: errorMessage
  };
  var isCreateQuoteError = errorCode === null || errorCode === void 0 ? void 0 : errorCode.includes(TOGO_DELIVERY_FLOW_ERRORS.CREATEQUOTE);
  var isCreateDeliveryError = errorCode === null || errorCode === void 0 ? void 0 : errorCode.includes(TOGO_DELIVERY_FLOW_ERRORS.CREATEDELIVERY);

  if (isCreateQuoteError || isCreateDeliveryError) {
    // as per the contract only 400 or 500 are allowed
    finalError.code = statusCode === ERROR_RESPONSE_STATUS_CODE.ERROR_400 // 400
    ? isCreateQuoteError ? TOGO_DELIVERY_SUBMIT_ORDER_ERROR_CODES.CREATE_QUOTE_GENERIC_ERROR : TOGO_DELIVERY_SUBMIT_ORDER_ERROR_CODES.CREATE_DELIVERY_GENERIC_ERROR : isCreateQuoteError //500
    ? TOGO_DELIVERY_SUBMIT_ORDER_ERROR_CODES.DELIVERY_UNAVAILABLE : TOGO_DELIVERY_SUBMIT_ORDER_ERROR_CODES.CREATE_DELIVERY_FAILED;

    if (isCreateDeliveryError && statusCode === ERROR_RESPONSE_STATUS_CODE.ERROR_400 && errorMessage.includes(TOGO_DELIVERY_FLOW_ERRORS.USED_QUOTE)) {
      finalError.errorMessage = TOGO_DELIVERY_FLOW_ERROR_MESSAGES.USED_QUOTE;
    }
  } else if (Object.keys(TOGO_DELIVERY_FLOW_PAYMENT_ERRORS).includes(errorCode)) {
    //payment errors
    finalError.code = TOGO_DELIVERY_SUBMIT_ORDER_ERROR_CODES.DELIVERY_FLOW_PAYMENT_ERROR;
  } else if ([TOGO_DELIVERY_FLOW_ERRORS.DRI_100, TOGO_DELIVERY_FLOW_ERRORS.DRI_102, TOGO_DELIVERY_FLOW_ERRORS.DRI_103, TOGO_DELIVERY_FLOW_ERRORS.CRT_426].includes(errorCode)) {
    finalError.code = TOGO_DELIVERY_SUBMIT_ORDER_ERROR_CODES.ERROR_REQUEST_FAILED_OR_TIMED_OUT;
  } else if (errorCode === TOGO_DELIVERY_FLOW_ERRORS.DRI_570 && errorMessage !== null && errorMessage !== void 0 && errorMessage.includes(TOGO_DELIVERY_FLOW_ERRORS.CHECK_NOT_FOUND_BY_ORDER_ID)) {
    finalError.code = TOGO_DELIVERY_SUBMIT_ORDER_ERROR_CODES.CHECK_NOT_FOUND_BY_ORDER_ID_OR_SESSION_ERROR;
  } else if (finalError.code === TOGO_DELIVERY_FLOW_ERRORS.CRT_448) {
    finalError.code = TOGO_DELIVERY_INITIATE_CHECKOUT_ERROR_CODES.RESTAURANT_CLOSING_SOON;
  } else if (errorCode.includes(TOGO_DELIVERY_FLOW_ERRORS.UPDATE_DELIVERY_ERROR_NO_RETRY)) {
    finalError.code = TOGO_DELIVERY_SUBMIT_ORDER_ERROR_CODES.DELIVERY_ERROR_QUIT_FLOW;
  }

  return decodedError(finalError);
}

function decodedError(error) {
  try {
    var _error$errorMessage;

    if ((_error$errorMessage = error.errorMessage) !== null && _error$errorMessage !== void 0 && _error$errorMessage.includes("::")) {
      var splitErrorMessages = error.errorMessage.split("::");
      var errorMessage = splitErrorMessages.length === 2 ? splitErrorMessages[1] : splitErrorMessages.slice(2).filter(function (_, index) {
        return index % 2 === 1;
      }).join("\n");
      error.errorMessage = _.startCase(_.toLower(errorMessage));
    }
  } catch (decodeError) {
    console.log("*#* error while decoding: ", decodeError, " original Error: ", error);
  }

  return error;
}

export var GetQuoteUIError = /*#__PURE__*/function (_UIError3) {
  _inherits(GetQuoteUIError, _UIError3);

  var _super5 = _createSuper(GetQuoteUIError);

  function GetQuoteUIError(data) {
    var _this5;

    _classCallCheck(this, GetQuoteUIError);

    _this5 = _super5.call(this, data);

    if (axios.isAxiosError(data)) {
      var _error$errors, _error$errors$, _error$statusCode, _error$errors2;

      var error = data.response.data;
      var finalError = determineUIErrorCode((_error$errors = error.errors) === null || _error$errors === void 0 ? void 0 : (_error$errors$ = _error$errors[0]) === null || _error$errors$ === void 0 ? void 0 : _error$errors$.errorCode, (_error$statusCode = error.statusCode) === null || _error$statusCode === void 0 ? void 0 : _error$statusCode.toString(), (_error$errors2 = error.errors) === null || _error$errors2 === void 0 ? void 0 : _error$errors2[0].errorMessage);
      _this5.errors = [{
        title: "Unexpected Error",
        message: finalError.errorMessage,
        code: finalError.code
      }];
    } else {
      // we expect the data to be of axios
      console.log("*#* error not of type IAPIError: ", {
        data: data
      });
      _this5.errors = [{
        title: "Unexpected Error",
        message: data.message
      }];
    }

    return _this5;
  }

  return GetQuoteUIError;
}(UIError);